export default "__VITE_ASSET__B6mxPZ9E__"